export const StorageTypes = {
  SORT_ORDER: 'sort_order',
};
